<div class="row">
    <div class="col">
        <h5>Todas as regiões</h5>
        <ng-container *ngTemplateOutlet="treeBranch; context: { tree: regionList }"></ng-container>
    </div>
    <div class="col-6">
        <h5>Bairros Selecionados ({{ selectedCities.length }})</h5>
        <button [hidden]="!selectedCities.length" class="btn btn-outline-danger btn-sm mb-2" (click)="removeAll()">Limpar Lista</button>
        <br>
        <span *ngFor="let city of selectedCities | slice: 0: showAllSelectedCities ? selectedCities.length : 50" class="badge badge-pill badge-light mr-1">
            {{ city.label }}
            <button class="btn btn-link text-danger btn-sm p-1" (click)="remove(city)">&times;</button>
        </span>
        <ng-container *ngIf="selectedCities.length">
            <a (click)="showAllSelectedCities = !showAllSelectedCities" class="btn badge badge-pill badge-primary">
                {{ showAllSelectedCities ? 'Esconder' : 'Mostar mais' }}
            </a>
        </ng-container>
        <span class="text-muted" [hidden]="selectedCities.length">
            Nenhum bairro selecionado.
        </span>
    </div>
</div>

<ng-template #treeBranch let-tree="tree">
    <div *ngFor="let item of tree" class="tree-item">
        <div (click)="item.children ? item.expanded = !item.expanded : undefined">
            <button class="btn btn-link btn-sm chevron-button" [class.invisible]="!item.children"
                [class.expanded]="item.expanded">
                <i class="material-icons">chevron_right</i>
            </button>
            <label [for]="'checkbox-' + item.value">
                <input type="checkbox" class="checkbox-lg" [(ngModel)]="item.selected" [id]="'checkbox-' + item.value"
                     *ngIf="!item.children" (ngModelChange)="toggleItem(item)" >
                <span class="checkbox-title">
                    <strong>{{ item.label }}</strong>
                    <span class="ml-1 mr-2" [hidden]="!item.children">({{ item.children?.length }})</span>
                </span>
            </label>
            <button class="btn btn-link text-primary btn-sm" (click)="selectChildren(item)" [hidden]="!item.children">Selecionar todos</button>
        </div>
        <div class="pl-4" *ngIf="item.expanded && item.children">
            <ng-container *ngTemplateOutlet="treeBranch; context: { tree: item.children }"></ng-container>
        </div>
    </div>
</ng-template>